export default __webpack_public_path__ + "static/media/clobber4.132caac2.png";